module.exports = __webpack_public_path__ + "static/media/badge.a830f9d7.png";